import { render, staticRenderFns } from "./AddAssignment.vue?vue&type=template&id=032890da&scoped=true&"
import script from "./AddAssignment.vue?vue&type=script&lang=js&"
export * from "./AddAssignment.vue?vue&type=script&lang=js&"
import style0 from "./AddAssignment.vue?vue&type=style&index=0&id=032890da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032890da",
  null
  
)

export default component.exports